import React from "react";
import { List, ListItem, ListItemText, Stack } from "@mui/material";
import { CustomModal } from "@/components/Modal";
import { Button, ButtonVariantOption } from "@/components/Button";
import { PageTitle } from "@/components/Title";
import { SizingWrapperStyle } from "@/components/Wrapper";
import type { DesignPreviewModalProps } from "@/features/dmManagement/types";

/**
 * デザインプレビューモーダル
 * デザインの構成ファイルを一覧表示し、各ファイルのプレビューを別タブで開く
 */
export const DesignPreviewModal: React.FC<DesignPreviewModalProps> = ({
  open,
  onClose,
  components,
}) => {
  const handlePreview = (previewUrl: string): void => {
    window.open(previewUrl, "_blank");
  };

  const handleModalClose = (
    _event: Record<string, unknown>,
    _reason: "backdropClick" | "escapeKeyDown"
  ): void => {
    onClose();
  };

  return (
    <CustomModal
      isOpen={open}
      handleClose={handleModalClose}
      ariaLabelledby="design-preview-modal"
      ariaDescribedby="design-preview-modal-description"
      width={"500px"}
      maxHeight={"90vh"}
      overflow="auto"
    >
      <Stack direction={"column"} spacing={3}>
        <PageTitle>デザインプレビュー</PageTitle>
        <List>
          {components.map((component) => (
            <ListItem
              key={component.id}
              secondaryAction={
                <Button
                  label="表示"
                  variant={ButtonVariantOption.Outlined}
                  size={SizingWrapperStyle.INHERIT}
                  onClick={() => {
                    handlePreview(component.previewUrl);
                  }}
                />
              }
            >
              <ListItemText
                primary={`${component.enclosingSeq + 1}. ${
                  component.productName
                }`}
              />
            </ListItem>
          ))}
        </List>
        <Stack
          direction={"row"}
          spacing={2}
          marginTop={2}
          justifyContent={"center"}
        >
          <Button
            label="閉じる"
            onClick={onClose}
            size={SizingWrapperStyle.INHERIT}
            variant={ButtonVariantOption.Outlined}
          />
        </Stack>
      </Stack>
    </CustomModal>
  );
};
